import { isCanlan } from '../utils/customer-name'

export const sportninjaOrigin = 'https://app.sportninja.com'
export const canlanOrigin = 'https://canlanstats.sportninja.com'

const appOrigin = isCanlan ? canlanOrigin : sportninjaOrigin
export default appOrigin
